import * as React from "react"
import parse from "html-react-parser"

import "./content_section.scss";

function ContentSection({sectionContent}) {

  return (
    <div className="content-section" id="content-section">
      <section itemProp="articleHeader" className="content-header">
        {parse(sectionContent.headline)}
      </section>
      {!!sectionContent.content && (
        <section itemProp="articleBody" className="resource-body">
          {parse(sectionContent.content)}
        </section>
      )} 
      {!!sectionContent.pullquote && (
        <section itemProp="articleBody" className="pull-quote">
        {parse(sectionContent.pullquote)}
      </section>
      )}  
    </div>
  )
}
export default ContentSection;
